
import { envConfig } from "@/lib/constants";
import Popup from "@/components/Popup.vue";
import { Component, MixedVue, mixins } from "@/vue";
import { gettersInstance } from "@/lib/util";

@Component({
  name: "CookieConsent",
  components: { Popup },
})
export default class CookieConsent extends mixins(MixedVue, gettersInstance(["userEmail"])) {
  static components: {
    Popup: typeof Popup;
  };

  dialogDismissed = document.cookie.includes("cookie_consent=");

  get trackersEnabled() {
    return envConfig.VUE_APP_ENABLE_TRACKERS === "true";
  }

  get todayDate() {
    return new Date().toDateString();
  }

  get cookieMaxAge() {
    return 15 * 365 * 24 * 60 * 60; // 15 years
  }

  acceptCookies() {
    document.cookie = `cookie_consent=YES+${this.todayDate}; max-age=${this.cookieMaxAge}`;
    window.location.reload();
  }

  declineCookies() {
    document.cookie = `cookie_consent=NO+${this.todayDate}; max-age=${this.cookieMaxAge}`;
    this.dialogDismissed = true;
  }
}
